@if (dateSpan() === 'sameDay') {
  <app-icon-label icon="event" [text]="startDate() | danishDate: 'weekdayDate' | capitalizeFirst" />
  <app-icon-label
    icon="schedule"
    [text]="'kl. ' + (startDate() | danishDate: 'time') + ' - ' + (endDate() | danishDate: 'time') | capitalizeFirst"
  />
}
@if (dateSpan() === 'multiDay') {
  <app-icon-label
    icon="date_range"
    [text]="(startDate() | danishDate: 'weekdayDate') + ' - kl. ' + (startDate() | danishDate: 'time') | capitalizeFirst"
  />
  <app-icon-label
    icon="date_range"
    [text]="(endDate() | danishDate: 'weekdayDate') + ' - kl. ' + (endDate() | danishDate: 'time') | capitalizeFirst"
  />
}
